import * as _ from 'lodash';
export function last(array) {
    return array[array.length - 1];
}
export function first(array) {
    return array[0];
}
export function convertCssValueToConfig(cssValue) {
    if (/^(\d+px)$/.test(cssValue)) {
        var n = /\d+/.exec(cssValue)[0];
        return { num: parseInt(n, 10), unit: 'px' };
    }
    else if (/^(\d+\.\d+px)$/.test(cssValue)) {
        var n = /\d+\.\d+/.exec(cssValue)[0];
        return { num: parseFloat(n), unit: 'px' };
    }
    return null;
}
export function convertConfigToNumber(dimensions, base) {
    var unit = dimensions.unit, num = dimensions.num;
    if (unit === 'px') {
        return num;
    }
    if (unit === '%' && _.isNumber(num)) {
        return base * (num / 100);
    }
    return 0;
}
export function all() {
    var promises = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        promises[_i] = arguments[_i];
    }
    return Promise.all(promises);
}
export function isSantaFullWidthMode(props) {
    var width = props.globals.dimensions.width;
    return String(width) === '';
}
export function emptyArrayOf(n, initialValue) {
    return Array(n).fill(initialValue);
}
export function stripHtmlTags(input) {
    return input.replace(/<(?:.|\n)*?>/gm, '');
}
export function capitalizeFirstLetters(string) {
    if (string === void 0) { string = ''; }
    return string
        .split(' ')
        .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1).toLocaleLowerCase(); })
        .join(' ');
}
//# sourceMappingURL=utils.js.map